import sectionCardFeatureCss from '../css-snippets/section-card-feature';

const html = ` 
<style>${sectionCardFeatureCss}</style>
<div
  class="card-feature-wrapper"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-position="left" 
  data-show-media="true"
>
  <div class="card-feature-container container">
    <div class="card-feature-left">
      <div class="card-feature-image">
        <video width="100%" height="auto" autoplay="" muted="" loop="" playsinline="">
          <source
            data-attribute="card-video"
            src="https://deals.getairmoto.com/assets/airmoto/video/timelapse.webm"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
    <div class="card-feature-right">
      <div class="card-feature-content">
        <h2>
          <strong>Quick, Portable and Convenient</strong>
        </h2>
        <p>
         Airmoto is the perfect solution for all your inflation needs. With its powerful 120 PSI, you can inflate virtually anything in minutes with the push of a button.
        </p>
      </div>
      <div class="card-feature-list">
        <div class="card-feature-item">
          <div class="card-feature-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/24/image-699d2bcd9bd4971f1fbce123.webp?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-feature-item-text">
            <p style="text-align: center;">
              <strong>Cars</strong>
            </p>
            <p style="text-align: center;">
              In under 6 minutes.
            </p>
          </div>
        </div>
        <div class="card-feature-item">
          <div class="card-feature-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/24/image-699d2be728b1a616e1b20bf4.webp?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-feature-item-text">
            <p style="text-align: center;">
              <strong>Truck</strong>
            </p>
            <p style="text-align: center;">
              In under 8 minutes.
            </p>
          </div>
        </div>
        <div class="card-feature-item">
          <div class="card-feature-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/24/image-699d2bfcc9b0bcb8b32b62a6.webp?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-feature-item-text">
            <p style="text-align: center;">
              <strong>Motorcycles</strong>
            </p>
            <p style="text-align: center;">
              In under 4 minutes.
            </p>
          </div>
        </div>
        <div class="card-feature-item">
          <div class="card-feature-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/24/image-699d2c1a0c484902ccfd48a0.webp?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-feature-item-text">
            <p style="text-align: center;">
              <strong>Bicycles</strong>
            </p>
            <p style="text-align: center;">
              In under 3 minutes.
            </p>
          </div>
        </div>
        <div class="card-feature-item">
          <div class="card-feature-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/24/image-699d2ce56d57f6dabd595aad.webp?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-feature-item-text">
            <p style="text-align: center;">
              <strong>Sports</strong>
            </p>
            <p style="text-align: center;">
              In under 2 minutes.
            </p>
          </div>
        </div>
        <div class="card-feature-item">
          <div class="card-feature-item-image">
            <img
              src="https://cdn.skyfastimg.com/images/2026/02/24/image-699d2c40c8755dd3bf7829a3.webp?w=50&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="card-feature-item-text">
            <p style="text-align: center;">
              <strong>And More</strong>
            </p>
            <p style="text-align: center;">
              In just minutes.
            </p>
          </div>
        </div>
      </div>
      <div class="card-feature-footer">
        <p style="text-align: center;">
          *Times vary by tire size and amount of air needed.
        </p>
      </div>
    </div>
  </div>
</div>
`;

export default html;
